import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OnBackgroundText, SectionLabel, Surface } from 'features/ui';
import { EnrollmentHero } from './EnrollmentHero';
import { EnrollmentPath } from './EnrollmentPath';
import type {
  EnrollmentShape,
  EnrollmentStep,
  OpenEnrollmentPhase,
} from '../types';

type EnrollmentBodyProps = {
  phase: OpenEnrollmentPhase;
  shape: EnrollmentShape;
  steps: EnrollmentStep[];
  onCta?: (() => void) | undefined;
  isCtaResolving?: boolean | undefined;
  isCtaResuming?: boolean | undefined;
};

export const EnrollmentBody = ({
  phase,
  shape,
  steps,
  onCta,
  isCtaResolving,
  isCtaResuming,
}: EnrollmentBodyProps) => {
  const { t } = useTranslation();
  return (
    <Stack spacing={2.5}>
      <EnrollmentHero
        phase={phase}
        shape={shape}
        onCta={onCta}
        isCtaResolving={isCtaResolving}
        isCtaResuming={isCtaResuming}
      />
      {steps.length > 1 && (
        <Box>
          <SectionLabel>
            <OnBackgroundText>{t('EnrollmentSectionLabel')}</OnBackgroundText>
          </SectionLabel>
          <Surface sx={{ p: 2.25 }}>
            <EnrollmentPath steps={steps} />
          </Surface>
        </Box>
      )}
      <Typography
        sx={{
          fontSize: 12,
          color: 'text.tertiary',
          textAlign: 'center',
          lineHeight: 1.5,
          px: 1,
        }}
      >
        <OnBackgroundText multiline>{t('EnrollmentFooter')}</OnBackgroundText>
      </Typography>
    </Stack>
  );
};
